import { ap, chain, map, of } from "./";
/**
 * Lift monadic for `Fold`. Should be prefered over `Fold.liftA` as `chain`
 * allows for ignore the `empty path` leading to more performant optics.
 *
 * @param g Function that lifts all the fold values.
 * @param ...rest All of the arguments of type `Fold`. Amount of params here need to match amount of arguments in `g`.
 * @return The resulting value of applying `g` to `rest`.
 */
export function liftM(g, ...rest) {
    // apply every arg to function
    const ffunc = rest.reduce((ff, aa) => chain((a) => map((f) => f.bind(undefined, a), ff), aa), of(g));
    // run the function inside
    return map((f) => f(), ffunc);
}
export function liftMRecord(record) {
    const x = Object.keys(record).reduce((ff, key) => {
        const fa = record[key];
        return chain((a) => map((f) => (Object.assign(Object.assign({}, a), { [key]: f })), fa), ff);
    }, of({}));
    return x;
}
export const liftA2 = (g, ca, cb) => ap(map(g, ca), cb);
export const liftA3 = (g, ca, cb, cc) => ap(ap(map(g, ca), cb), cc);
export const liftA4 = (g, ca, cb, cc, cd) => ap(ap(ap(map(g, ca), cb), cc), cd);
export const liftA5 = (g, ca, cb, cc, cd, ce) => ap(ap(ap(ap(map(g, ca), cb), cc), cd), ce);
export const liftA6 = (g, ca, cb, cc, cd, ce, cf) => ap(ap(ap(ap(ap(map(g, ca), cb), cc), cd), ce), cf);
export const liftA7 = (g, ca, cb, cc, cd, ce, cf, cg) => ap(ap(ap(ap(ap(ap(map(g, ca), cb), cc), cd), ce), cf), cg);
export const liftA8 = (g, ca, cb, cc, cd, ce, cf, cg, ch) => ap(ap(ap(ap(ap(ap(ap(map(g, ca), cb), cc), cd), ce), cf), cg), ch);

